import { gql } from 'apollo-boost'

export const BROKERS = gql`
  query brokers {
    brokers{
      __typename
      ... on Brokers {
        brokers {
          brokerID
          name
          exchange
        }
      }
      ... on Error {
        code
        message
      }
    }
  }
`